/* Resolve large products on Shopify instead of using the truncated variant array. */
(function() {
  'use strict';

  window.theme = window.theme || {};

  function HighVariantPicker(options) {
    this.container = options.container;
    this.originalSelectorId = options.originalSelectorId;
    this.singleOptionSelector = options.singleOptionSelector;
    this.enableHistoryState = options.enableHistoryState;
    this.dynamicVariantsEnabled = options.dynamicVariantsEnabled;
    this.productId = String(this.container.dataset.productId);
    this.productUrl = this.container.dataset.productUrl;
    this.form = this.container.querySelector('.product-single__form');
    this.currentVariant = null;
    this.variants = [];
    this.state = null;
    this.requestNumber = 0;
    this.pending = false;
    this.failed = false;
    this.destroyed = false;
    this.paymentStates = new Map();
    this.inputs = Array.from(this.container.querySelectorAll(this.singleOptionSelector));
    this.onChange = this._onChange.bind(this);
    this.onSubmit = this._guardPurchase.bind(this);
    this.onClick = this._guardAcceleratedCheckout.bind(this);
    this.onRetry = this._request.bind(this);
    this.inputs.forEach(function(input) {
      input.addEventListener('change', this.onChange);
    }, this);
    if (this.form) this.form.addEventListener('submit', this.onSubmit, true);
    this.container.addEventListener('click', this.onClick, true);

    try {
      var node = this.container.querySelector('[data-ptv-variant-state]');
      var state = JSON.parse(node.textContent);
      this.state = state;
      this._validateState(state, this._selectedValueIds());
      this._commit(state, false);
    } catch (error) {
      this._fail();
    }
  }

  HighVariantPicker.prototype = {
    _selectedValueIds: function() {
      var values = [];
      this.inputs.forEach(function(input) {
        var value;
        if (input.tagName === 'SELECT') {
          value = input.options[input.selectedIndex];
        } else if (input.checked) {
          value = input;
        }
        if (value) values.push({ position: Number(input.dataset.index.replace('option', '')), id: value.dataset.optionValueId });
      });
      values.sort(function(a, b) { return a.position - b.position; });
      return values.map(function(value) { return String(value.id || ''); });
    },

    _getCurrentOptions: function() {
      return theme.Variants.prototype._getCurrentOptions.call(this);
    },

    _validateState: function(state, requestedIds) {
      if (!state || String(state.productId) !== this.productId || !Array.isArray(state.options) || !state.options.length) {
        throw new Error('Invalid product state');
      }
      if (requestedIds.length !== state.options.length || requestedIds.some(function(id) { return !/^\d+$/.test(id); })) {
        throw new Error('Missing option value');
      }
      var selectedIds = state.selectedOptionValueIds;
      if (!Array.isArray(selectedIds) || selectedIds.length !== requestedIds.length || selectedIds.some(function(id, index) { return String(id) !== requestedIds[index]; })) {
        throw new Error('Unexpected selected options');
      }
      var selectedNames = [];
      state.options.forEach(function(option, index) {
        if (option.position !== index + 1 || !Array.isArray(option.values)) throw new Error('Invalid option state');
        var selected = option.values.filter(function(value) { return value.selected; });
        if (selected.length !== 1 || String(selected[0].id) !== requestedIds[index]) throw new Error('Selection was not resolved');
        selectedNames.push(selected[0].name);
      });
      if (state.variant && (!/^\d+$/.test(String(state.variant.id)) || !Array.isArray(state.variant.options) || state.variant.options.length !== selectedNames.length || state.variant.options.some(function(value, index) { return value !== selectedNames[index]; }))) {
        throw new Error('Variant does not match the selection');
      }
    },

    _onChange: function(event) {
      this.lastChanged = { value: event.target.value, index: event.target.dataset.index };
      this._request();
    },

    _request: function() {
      if (this.destroyed) return;
      var requestNumber = ++this.requestNumber;
      if (this.controller) this.controller.abort();
      clearTimeout(this.timeout);
      this.controller = new AbortController();
      this.pending = true;
      this.failed = false;
      this.currentVariant = null;
      this._setMasterVariant(null);
      this._setPurchaseState(false);
      this._showError(false);
      this.container.setAttribute('aria-busy', 'true');
      var selectedIds = this._selectedValueIds();
      var url;
      try {
        if (!selectedIds.length || selectedIds.some(function(id) { return !/^\d+$/.test(id); })) throw new Error('Missing option value');
        url = new URL(this.productUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid product URL');
        url.searchParams.delete('variant');
        url.searchParams.set('section_id', 'ptv-variant-state');
        url.searchParams.set('option_values', selectedIds.join(','));
        var previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      } catch (error) {
        this._fail();
        return;
      }
      this.timeout = setTimeout(function() { this.controller.abort(); }.bind(this), 12000);
      fetch(url.toString(), {
        credentials: 'same-origin',
        signal: this.controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Product state request failed');
        return response.text();
      }).then(function(html) {
        if (this.destroyed || requestNumber !== this.requestNumber) return;
        var documentState = new DOMParser().parseFromString(html, 'text/html');
        var node = documentState.querySelector('[data-ptv-variant-state]');
        if (!node) throw new Error('Missing product state');
        var state = JSON.parse(node.textContent);
        this._validateState(state, selectedIds);
        this._commit(state, true);
      }.bind(this)).catch(function() {
        if (!this.destroyed && requestNumber === this.requestNumber) this._fail();
      }.bind(this)).finally(function() {
        if (requestNumber === this.requestNumber) clearTimeout(this.timeout);
      }.bind(this));
    },

    _commit: function(state, dispatchEvents) {
      this.state = state;
      this.pending = false;
      this.failed = false;
      this.container.removeAttribute('aria-busy');
      this._showError(false);
      this._applyOptionState(state.options);
      var variant = state.variant || null;
      if (variant && state.inventory) {
        window.inventories = window.inventories || {};
        window.inventories[this.productId] = window.inventories[this.productId] || {};
        window.inventories[this.productId][variant.id] = state.inventory;
      }
      this._setMasterVariant(variant);
      this._setPurchaseState(!!(variant && variant.available));
      this.currentlySelectedValues = this._getCurrentOptions();
      if (dispatchEvents) {
        var detail = {
          variant: variant,
          currentlySelectedValues: this.currentlySelectedValues,
          value: this.lastChanged && this.lastChanged.value,
          index: this.lastChanged && this.lastChanged.index
        };
        this.container.dispatchEvent(new CustomEvent('variantChange', { detail: detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail: detail }));
        if (variant) {
          ['_updateImages', '_updatePrice', '_updateUnitPrice', '_updateSKU'].forEach(function(method) {
            theme.Variants.prototype[method].call(this, variant);
          }, this);
        }
        if (this.enableHistoryState) this._updateHistory(variant);
      }
      this.currentVariant = variant;
      this.variants = variant ? [variant] : [];
    },

    _applyOptionState: function(options) {
      this.inputs.forEach(function(input) {
        var option = options[Number(input.dataset.index.replace('option', '')) - 1];
        if (!option) return;
        if (input.tagName === 'SELECT') {
          Array.from(input.options).forEach(function(element) {
            var value = option.values.find(function(value) { return String(value.id) === element.dataset.optionValueId; });
            if (!value) { element.disabled = true; element.selected = false; return; }
            element.disabled = this.dynamicVariantsEnabled && !value.available;
            element.selected = !!value.selected;
          }, this);
        } else {
          var value = option.values.find(function(value) { return String(value.id) === input.dataset.optionValueId; });
          var disabled = !value || (this.dynamicVariantsEnabled && !value.available);
          input.checked = !!(value && value.selected);
          input.classList.toggle('disabled', disabled);
          var label = input.parentElement.querySelector('label');
          if (label) label.classList.toggle('disabled', disabled);
          if (input.checked) input.dispatchEvent(new Event('updateSwatch'));
        }
      }, this);
    },

    _setMasterVariant: function(variant) {
      var select = this.container.querySelector(this.originalSelectorId);
      if (!select) return;
      if (select.tagName === 'SELECT') {
        var option = document.createElement('option');
        option.value = variant ? String(variant.id) : '';
        option.textContent = variant ? variant.title : '';
        option.selected = true;
        select.replaceChildren(option);
      }
      select.value = variant ? String(variant.id) : '';
      select.disabled = !variant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    },

    _setPurchaseState: function(enabled) {
      this.container.querySelectorAll('[data-add-to-cart]').forEach(function(button) {
        button.disabled = !enabled;
        button.classList.toggle('disabled', !enabled);
      });
      this.container.querySelectorAll('.shopify-payment-button').forEach(function(element) {
        if (!this.paymentStates.has(element)) {
          this.paymentStates.set(element, { inert: element.inert, aria: element.getAttribute('aria-disabled'), pointerEvents: element.style.pointerEvents });
        }
        var original = this.paymentStates.get(element);
        element.inert = enabled ? original.inert : true;
        element.style.pointerEvents = enabled ? original.pointerEvents : 'none';
        if (!enabled) element.setAttribute('aria-disabled', 'true');
        else if (original.aria === null) element.removeAttribute('aria-disabled');
        else element.setAttribute('aria-disabled', original.aria);
      }, this);
    },

    _guardPurchase: function(event) {
      if (!this.pending && !this.failed && this.currentVariant && this.currentVariant.available) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.failed) this._showError(true);
    },

    _guardAcceleratedCheckout: function(event) {
      if (event.target.closest && event.target.closest('.shopify-payment-button')) this._guardPurchase(event);
    },

    _fail: function() {
      this.pending = false;
      this.failed = true;
      this.currentVariant = null;
      this.container.removeAttribute('aria-busy');
      this._setMasterVariant(null);
      this._setPurchaseState(false);
      this._showError(true);
    },

    _showError: function(visible) {
      if (visible && !this.errorElement) {
        this.errorElement = document.createElement('div');
        this.errorElement.className = 'errors';
        this.errorElement.setAttribute('data-ptv-variant-error', '');
        this.errorElement.setAttribute('role', 'alert');
        var message = document.createElement('p');
        message.textContent = this.state && this.state.errorMessage || theme.strings.unavailable;
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'btn btn--tertiary';
        retry.textContent = this.state && this.state.retryLabel || theme.strings.unavailable;
        retry.addEventListener('click', this.onRetry);
        this.errorElement.append(message, retry);
        (this.form || this.container).append(this.errorElement);
      }
      if (this.errorElement) this.errorElement.hidden = !visible;
    },

    _updateHistory: function(variant) {
      if (!window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (variant) {
        url.searchParams.set('variant', variant.id);
        url.searchParams.delete('option_values');
      } else {
        url.searchParams.delete('variant');
        url.searchParams.set('option_values', this._selectedValueIds().join(','));
      }
      window.history.replaceState(window.history.state, '', url.toString());
    },

    destroy: function() {
      this.destroyed = true;
      this.requestNumber++;
      clearTimeout(this.timeout);
      if (this.controller) this.controller.abort();
      this.inputs.forEach(function(input) { input.removeEventListener('change', this.onChange); }, this);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
      this.container.removeEventListener('click', this.onClick, true);
      if (this.errorElement) this.errorElement.remove();
    }
  };

  theme.HighVariantPicker = HighVariantPicker;
})();
